var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEbay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 36,
    viewBox: "0 0 91 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1072_3007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9325 7.85352C5.61258 7.85352 0.346191 10.542 0.346191 18.6533C0.346191 25.0791 3.88746 29.1257 12.0957 29.1257C21.7572 29.1257 22.3766 22.744 22.3766 22.744H17.6951C17.6951 22.744 16.6913 26.1804 11.8101 26.1804C7.83452 26.1804 4.97509 23.4874 4.97509 19.7128H22.8662V17.3442C22.8662 13.6099 20.5019 7.85352 11.9325 7.85352ZM11.7693 10.8807C15.5537 10.8807 18.1336 13.2054 18.1336 16.6897H5.07864C5.07864 12.9907 8.44613 10.8807 11.7693 10.8807Z",
    fill: "#E53238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8579 0V25.0532C22.8579 26.4752 22.7566 28.4721 22.7566 28.4721H27.2217C27.2217 28.4721 27.3819 27.038 27.3819 25.7272C27.3819 25.7272 29.5881 29.188 35.5865 29.188C41.903 29.188 46.1937 24.7906 46.1937 18.4904C46.1937 12.6296 42.2526 7.91573 35.5966 7.91573C29.3639 7.91573 27.4271 11.2906 27.4271 11.2906V0H22.8579ZM34.4442 11.0145C38.7336 11.0145 41.4612 14.2067 41.4612 18.4904C41.4612 23.084 38.3109 26.0892 34.4748 26.0892C29.8967 26.0892 27.4271 22.5049 27.4271 18.5313C27.4271 14.8289 29.6431 11.0145 34.4442 11.0145Z",
    fill: "#0064D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2906 7.85352C47.7827 7.85352 47.173 13.0737 47.173 13.9079H51.9053C51.9053 13.9079 52.1536 10.8603 56.9642 10.8603C60.0903 10.8603 62.5126 12.295 62.5126 15.0534V16.0351H56.9642C49.5984 16.0351 45.7043 18.1958 45.7043 22.5804C45.7043 26.8955 49.3022 29.2434 54.1645 29.2434C60.791 29.2434 62.9256 25.5718 62.9256 25.5718C62.9256 27.0321 63.038 28.4712 63.038 28.4712H67.2451C67.2451 28.4712 67.0818 26.6875 67.0818 25.5463V15.6823C67.0818 9.21463 61.8791 7.85352 57.2906 7.85352ZM62.5126 18.9806V20.2897C62.5126 21.9969 61.4619 26.2418 55.2763 26.2418C51.889 26.2418 50.4367 24.5467 50.4367 22.5804C50.4367 19.0035 55.3275 18.9806 62.5126 18.9806Z",
    fill: "#F5AF02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5352 8.67383H69.8591L77.4997 24.0232L85.1229 8.67383H89.9458L76.0602 36.0004H71.0014L75.0082 28.3828L64.5352 8.67383Z",
    fill: "#86B817"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1072_3007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 36,
    fill: "white",
    transform: "translate(0.346191)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbay);
export default __webpack_public_path__ + "static/media/ebay.d28a77989c6a966da0ce49596c2a7602.svg";
export { ForwardRef as ReactComponent };